import Icon from "../../Icon2/Icon";
import React from "react";

const FileUploadContainer = (props) => {
  const { handleDrop, errored, importFailedMessage, fileTypeErrorText, label} = props;
  const onFileSelect = (e: any) => {
    handleDrop(e.target.files);
  }
  const iconName = errored?.isError ? "FailedPreview" : "UploadFile";
  const className = errored?.isError ? "file-upload-container__errored" : "";
  return (
    <div className={`file-upload-container ${className}`}>
      <div className="file-upload-container__icon">
        <Icon version="v2" icon={iconName} size="original" />
      </div>
      {errored?.isError ? (
        <div className="file-upload-container__error-block">
          {errored?.message === 'fileType' ? (fileTypeErrorText ? fileTypeErrorText : "Please import files with the .CSV or .JSON format") : (errored?.message === 'multipleFiles' ? (`You can only import one ${label} file at a time.`) : (importFailedMessage))}
        </div>) : (null)}
      <div className="subtext" style={{ padding: "4px" }}>
      Drag and drop to upload or
        <label htmlFor="fileInput" className="file-upload-container__input-button-label" style={{textTransform:"none"}}>{"Choose a File"}</label>
        <input className="file-upload-container__input-button" type="file" id="fileInput" name="fileInput" accept=".csv, .json" onChange={onFileSelect} style={{ display: "none" }} />
      </div>
    </div>
  )
}

export default FileUploadContainer;